<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Cập nhật hệ thống</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div 
            v-if="errors_exist"  
            class="row"
          >
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-tabs
              v-model="tabs"
              grow
              show-arrows
            >
              <v-tabs-slider/>
              <v-tab
                class="primary--text"
              >
                Thông tin chung
              </v-tab>

              <v-tab
                class="primary--text"
              >
                Cấu hình khác
              </v-tab>
              <v-tab-item class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <label>Logo</label>
                    <input 
                      type="file" 
                      @change="onFilePicked" 
                      class="d-none" 
                      ref="fileInput" 
                      accept="image/*"
                    />
                    <div class="text-center">
                      <v-avatar
                        size="170"
                        tile
                      >
                        <v-hover v-slot="{ hover }">
                          <v-img
                            v-if="logo_url"
                            :src="logo_url"
                            class="mx-auto"
                            @click="onPickFile"
                            contain
                          >
                            <div v-if="hover" class="avatar-icon-upload">
                              <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                            </div>
                          </v-img>
                          <v-img
                            v-else
                            src="@/assets/NoImage.jpg"
                            class="mx-auto elevation-1"
                            @click="onPickFile"
                            contain
                          >
                            <div v-if="hover" class="avatar-icon-upload">
                              <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                            </div>
                          </v-img>
                        </v-hover>
                      </v-avatar>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.ten"
                      label="Tên hệ thống"
                      class="require"
                      hide-details
                      required
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.chu_quan"
                      label="Chủ quản"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="provinceSelected"
                      :items="provinces"
                      item-text="name"
                      item-value="matp"
                      label="Tỉnh/Thành phố"
                      class="require"
                      hide-details
                      return-object
                    >
                      <template #append-item>
                        <div class="append">
                          <v-text-field 
                            label="Lọc" 
                            placeholder="Lọc Tỉnh/Thành phố"
                            single-line
                            @input="provinceFilter"
                            append-icon="mdi-filter-variant"
                            class="px-4"
                            clearable
                          />
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.dia_chi"
                      label="Địa chỉ"
                      class="require"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="item.so_dien_thoai"
                      label="Điện thoại"
                      class="require"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="item.fax"
                      label="Fax"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.email"
                      label="Email"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.thiet_ke"
                      label="Thiết kế bởi"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.so_gp"
                      label="Số giấy phép"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="item.nguoi_cap"
                      label="Đơn vị cấp"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="item.ngay_cap"
                      label="Ngày cấp"
                      v-mask="'##/##/####'"
                      hide-details
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="auto"
                  >
                    <label>Mô tả</label>
                    <quill-editor 
                      v-model="item.last"
                      :options="editorOption"
                      style="min-height:150px;"
                    >
                    </quill-editor>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <label>Ảnh trình chiếu (hiển thị ở trang chủ): </label>
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      :destroyDropzone="false"
                      v-on:vdropzone-success="uploadSuccess"
                      v-on:vdropzone-error="uploadError"
                      v-on:vdropzone-removed-file="fileRemoved"
                      @vdropzone-mounted="loadPictures"
                    />
                    <div class="red--text text-center">
                      Lưu ý: Chỉ chấp nhận tập tin dạng: *.jpg, *.jpeg, *.png và kích thước <= 2MB
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapActions, mapState } from 'vuex';
  import SystemSevice from '@/services/System';
  export default {
    components: { 
      vueDropzone: vue2Dropzone,
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        tabs: 0,
        dialog: false,
        errors_exist: false,
        errors: [],
        logo_url: null,
        colors: ['primary', 'info', 'warning', 'pink'],
        colorSelected: null,
        images: [],
        dropzoneOptions: {
          url: null,
          addRemoveLinks: true,
          dictRemoveFile: "×",
          removeType: "server",
          dictDefaultMessage: "<i class='mdi mdi-24px mdi-arrow-collapse-up'></i> <div>Tải lên hình ảnh</div>",
          acceptedFiles: "image/jpeg,image/png,image/jpg",
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          headers: {
            "Authorization": `Bearer ${JSON.parse(localStorage.getItem('user')).token}`,
            "Cache-Control": null, 
            "X-Requested-With": null
          },
        },
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        },
        provinces: [],
        provinceSelected: null,
        invalidIds: []
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
      this.dropzoneOptions.url = `${this.config.beUrl}/api/v1/images`;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist = false;
        if (this.showDialog) {
          this.dialog = true;
          this.getProvinces();
          if(this.item.logo) {
            this.logo_url = `${this.config.beUrl}/uploads/${this.item.logo}`;
          }
          if(this.item.sliders){
            this.loadPictures();
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getProvinces () {
        const app = this;
        axios.get("api/v1/provinces")
          .then(response => {
            app.provinces = response.data;
            if(app.item.tinh_id){
              app.provinceSelected = app.provinces.find(
                element => element.matp === app.item.tinh_id
              );
            }
          })
          .catch(function (error) {
            app.openSnackbar({ 
              type: 'error',
              body: 'Lấy tỉnh/thành phố không thành công!'
            });
            SystemSevice.logging('systems.Form.getProvinces', error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/systems`;
        let data = item;

        data.images = app.images.filter(e => !app.invalidIds.includes(e.id));

        if(app.provinceSelected){
          data.tinh_id = app.provinceSelected.matp;
        }

        if (data.id) {
          method = "patch";
          url = `api/v1/systems/${data.id}`;
        }

        app.loading=true;
        
        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' })
            SystemSevice.logging('systems.Form.save', error.message);
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;

        const file = event.target.files[0];
        app.logo_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.logo=response.data.filePath;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải lên hình ảnh thành công!'
            });
          })
          .catch(function (error) {
            app.logo_url = null;
            app.openSnackbar({ type: 'error' });
            SystemSevice.logging('systems.Form.onFilePicked', error);
          });
      },
      uploadSuccess(file, response) {
        this.openSnackbar({ 
          type: 'success',
          body: 'Tải giấy chứng nhận lên thành công!'
        });
        file.previewElement.querySelector("[data-dz-name]").innerHTML = response.filePath;
        this.images.push(response.fileId);
      },
      uploadError(file, message) {
        this.openSnackbar({ type: 'error' });
        SystemSevice.logging('systems.Form.uploadError', error);
      },
      fileRemoved(file, error, xhr) {
        const app = this;
        if(app.dropzoneOptions.removeType == "server") {
          axios.post('api/v1/remove-slider', {
            systemId: app.item.id,
            fileName: file.previewElement.querySelector("[data-dz-name]").innerHTML
          })
            .then(function (response) {
              file.previewElement.remove();
              app.invalidIds.push(response.data);
              app.openSnackbar({ 
                type: 'success',
                body: 'Xóa giấy chứng nhận thành công!'
              });
            })
            .catch(function (error) {
              app.openSnackbar({ type: 'error' });
              SystemSevice.logging('systems.Form.fileRemoved', error);
            });
        } else {
          file.previewElement.remove();
        }
      },
      loadPictures() {
        if(this.$refs.myVueDropzone) {
          this.dropzoneOptions.removeType = "client";
          this.$refs.myVueDropzone.removeAllFiles();
          this.dropzoneOptions.removeType = "server";
          if(this.item.sliders) {
            this.item.sliders.forEach(image => {
              if(!this.invalidIds.includes(image.id)) {
                var file = { size: 123, name: image.path, type: "image/png" };
                var url = `${this.config.beUrl}/uploads/${image.path}`;
                this.$refs.myVueDropzone.manuallyAddFile(file, url);
              }
            });
          }
        }
      },
      provinceFilter(val) {
        if (!val) { 
          this.getProvinces(); 
        } else {
          let results = [];
          this.provinces.forEach(function(v,i){
            if(v.name.toLowerCase().includes(val.toLowerCase())){
              results.push(v);
            }
          });
          if(results.length){
            this.provinces=results;
          }
        }
      }
    }
  }
</script>
<style scoped>
  .append{
    position:sticky;
    bottom:0px;
    width:100%;
    display:flex;
    justify-content :center;
    background: #aee5bf;
    z-index: 1;
  }
  .avatar-icon-upload{
    position: absolute;
    background: gray;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    cursor: pointer;
  }
  .avatar-icon-upload .v-icon{
    font-size: 36px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>